import { render, staticRenderFns } from "./ConfrontationDraftListModal.vue?vue&type=template&id=887ba74c&scoped=true"
import script from "./ConfrontationDraftListModal.vue?vue&type=script&lang=js"
export * from "./ConfrontationDraftListModal.vue?vue&type=script&lang=js"
import style0 from "./ConfrontationDraftListModal.vue?vue&type=style&index=0&id=887ba74c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887ba74c",
  null
  
)

export default component.exports